import { ActionsColumn } from '@otp/ui';
import { UserMergeRequestListItem } from '../../types';
import { Remove } from '@otp/icons';
import { useState } from 'react';
import {
  DeleteUserProfileMergeRequestDocument,
  UserMergeRequestsDocument,
  UserMergeRequestStatus,
} from 'src/graphql/generated/graphql';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { DeleteConfirmation } from 'src/components/common/form/delete-confirmation';

type ProfileActionsFieldProps = {
  entity: UserMergeRequestListItem;
};

const QUERIES_TO_REFETCH = [UserMergeRequestsDocument];

export const ProfileActionsField = ({ entity }: ProfileActionsFieldProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'user-merge-requests.list',
  });

  const [isDeleting, setIsDeleting] = useState(false);

  const [deleteMutation] = useMutation(DeleteUserProfileMergeRequestDocument, {
    refetchQueries: QUERIES_TO_REFETCH,
  });

  const onDelete = () => {
    deleteMutation({
      variables: {
        id: entity.id,
      },
    });

    setIsDeleting(false);
  };

  if (entity.status !== UserMergeRequestStatus.Pending) {
    return null;
  }

  return (
    <>
      <ActionsColumn
        icons={[
          {
            icon: <Remove />,
            onClick: () => setIsDeleting(true),
          },
        ]}
      />
      <DeleteConfirmation
        objectTitle={entity.eIdsToMerge.join(', ')}
        objectType={t('eid-merge-requests-list')}
        open={isDeleting}
        onClose={() => setIsDeleting(false)}
        onConfirm={onDelete}
      />
    </>
  );
};
